const SET_BUCKETS = (state, data) => {
  state.buckets = data
}

const SET_DATA_BUCKETS = (state, data) => {
  state.dataBuckets = data
}

export default {
  SET_BUCKETS,
  SET_DATA_BUCKETS
}



// WEBPACK FOOTER //
// ./src/store/modules/user/products/mutations.js